<template>
  <a-card :bordered="false" class="m-b-20">
    <SmallSquare class="m-b-10" :content="'更新时间：'+thatDate" />
  </a-card>
     <a-spin :spinning="listLoading">

  <a-card :bordered="false" class="m-b-20">
    <div class="s_flex_ali">
      <div style="width:50%">
        <div ref="echartsLine" style="width:100%;height:400px"></div>
      </div>
      <div style="width:50%">
        <a-table :pagination='false'  bordered rowKey='out_warehousing_sn' :columns='columns' :data-source='list'>
           <template v-slot:ranking="{ record ,index}">
            {{record.ranking}} <span :style="'display: inline-block;width:20px;height:10px;background-color:'+color[index]" ></span>
         </template>
        </a-table>
      </div>
    </div>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <div style="display: flex;justify-content: space-between;">
         <a-radio-group v-model:value="search.warehouse_id"  @change="changNav()">
      <a-radio-button :value="v.warehouse_id" v-for="(v) in list" :key="v.warehouse_id" v-show="v.warehouse_position_name!='其它'">{{v.warehouse_position_name}}</a-radio-button>
    </a-radio-group>
    <a-radio-group v-model:value="search.type" @change="changNav()">
      <a-radio-button value="1" >入库</a-radio-button>
      <a-radio-button value="2" >出库</a-radio-button>
      <a-radio-button value="3" >退货</a-radio-button>
      <a-radio-button value="4" >调仓出</a-radio-button>
      <a-radio-button value="5" >调仓入</a-radio-button>
    </a-radio-group>
    </div>
    <div ref="echartsBar" style="width:100%;height:400px"></div>
  </a-card>
     </a-spin>
</template>
<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { warehousingPosition } from "@/api/antiFleeing";
import { message } from "ant-design-vue";

export default {
  components: {},
  setup() {
    const search = ref({
      warehouse_id: "",
      type: '1',
    });
    const state = reactive({
      list: [],
      total: 0,
      lineList: [],
      analyzeList: [],
      listLoading:false,
      thatDate: "",
      color: ["#02a7f0","#ffc000", "#70b603", "#8080ff", "#f59a23", "#f59a23",'#a5a5a5'],
    });
    const onSearch = () => {
      changNav();
    };
    let columns = [
      {
        title: "排名",
        dataIndex: "ranking",
        key: "ranking",
         slots: { customRender: "ranking" },
      },
      {
        title: "仓库名称",
        dataIndex: "warehouse_position_name",
        key: "warehouse_position_name",
      },
      {
        title: "库存数量",
        dataIndex: "stock_num",
        key: "stock_num",
      },
      {
        title: "占比",
        dataIndex: "value",
        key: "value",
      },
    ];
    var $moment = inject("momentTime");

    const getLine = async () => {
      state.listLoading=true
      let result = await warehousingPosition({
        ...search.value,
      })
        .then((res) => res.data)
        .catch((error) => error);
      // 整理数据
      state.listLoading=false
      var chartsList = [];
      var total = result.data.code_num;
      var top5Total = 0;
      let sort = 0
      result.data.chartList.forEach((element, k) => {
        sort = k + 1;
        top5Total += element.stock_num;
        chartsList.push({
          ranking: k + 1,
          ...element,
          name:element.warehouse_position_name,
          value: ((element.stock_num / total) * 100).toFixed(1),
        });
      });
      console.log(top5Total,total)
      if (top5Total < total) {
        chartsList.push({
          name: "其它",
          warehouse_position_name:'其它',
          ranking: sort+1,
          stock_num:'-',
          value:Math.abs(( ((top5Total - total) / total) * 100).toFixed(1)),
        });
      }
      state.list = chartsList;
      console.log(state.list,'2222')
      if (!search.value.warehouse_id) {
        search.value.warehouse_id = chartsList[0].warehouse_id;
      }
      state.lineList = result.data.lineList;
      return chartsList;
    };
    // 线性图表
    const echartsLine = ref("");
    // 柱图
    const echartsBar = ref("");
    var pie;
    var bar;
    const changNav = async () => {
      var lines = await getLine();
      pie.setOptions({
        title: {
          text: "TOP5品牌商仓库仓储占比",
        },
        tooltip: {
          trigger: "item",
          formatter: "占比{c}%",
        },
        series: [
          {
            data: Object.values(lines),
            type: "pie",
            radius: ['40%', '70%'],
            color: state.color,
            smooth: true,
          },
        ],
      });
      bar.setOptions({
        xAxis: {
          type: "category",
          data: state.lineList.map((v) => v.date),
        },
         tooltip: {
        trigger: 'axis',
        formatter: "商品销量：{c}",
      },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: state.lineList.map((v) => v.num),
            type: "bar",
            color: state.color,
          },
        ],
      });
    };
    onMounted(() => {
      // 当前时间
      state.thatDate = $moment().format("YYYY-MM-DD HH:mm:ss");
      pie = useECharts(echartsLine.value);
      bar = useECharts(echartsBar.value);
      changNav(1);
    });
    return {
      ...toRefs(state),
      search,
      changNav,
      onSearch,
      echartsLine,
      columns,
      echartsBar
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }
    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
</style>